import React from 'react';
import './styles.less';

const VipFeatures: React.FC = () => {
  return (
    <div className="vip-features-container">
      <div className="vip-title">
        <span className="title">橙子8设计</span>
        <span className="vip-badge">VIP</span>
      </div>
      
      <div className="vip-features">
        <div className="feature-section">
          <h4>会员专属功能</h4>
          <ul>
            <li>• 智能抠图，一键去除背景</li>
            <li>• 智能消除，轻松修复人像缺陷</li>
            <li>• 画质修复质感，从此告别渣画质</li>
            <li>• 医美级人像美容，修出自然美颜</li>
            <li>• 证件照设计，轻松换装换背景</li>
            <li>• 自由网格拼图，拼你所想</li>
          </ul>
        </div>

        <div className="feature-section">
          <h4>会员专属内容</h4>
          <ul>
            <li>• 海量模板快速出图，个人商用无忧</li>
            <li>• 滤镜/花字/贴纸素材，持续更新</li>
          </ul>
        </div>

        {/* <div className="feature-section">
          <h4>会员到哪儿都能用</h4>
          <ul>
            <li>• APP、Web</li>
          </ul>
        </div> */}
      </div>
    </div>
  );
};

export default VipFeatures;